import React, { AnchorHTMLAttributes } from 'react';
import { Link } from 'react-router-dom';

export interface GotToEditLinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  hasError?: boolean;
}

export const GotToEditLink: React.FC<GotToEditLinkProps> = React.forwardRef<HTMLAnchorElement, GotToEditLinkProps>(
  ({ className, href, hasError, ...anchorProps }, ref) => {
    return (
      <Link
        ref={ref}
        to={href}
        className={`
            flex flex-row items-center flex-nowrap whitespace-nowrap
            px-1.5 rounded
            text-[13px] font-sans font-medium leading-normal
            hover:bg-voxel-gray-50
            select-none
            ${hasError && 'text-red-400 bg-red-50 hover:bg-red-100'}
            cursor-pointer
            ${className}
        `}
        {...anchorProps}
      />
    );
  }
);

export default GotToEditLink;
